export default "__VITE_ASSET__DwRDIuzQ__"